import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, booted } = useAuth();

  if (!booted || user === null) {
    return (
      <div
        className="flex h-screen w-full items-center justify-center bg-gray-50"
        data-testid="auth-boot-loader"
      >
        <Loader2 className="h-6 w-6 animate-spin text-[#1e3a5f]" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  // Safety net: users who still owe a password change are sent back to the
  // login flow, which resumes at the forced change-password step.
  if (user.mustChangePassword) return <Navigate to="/login" replace />;
  return children;
}
